module.exports = __webpack_public_path__ + "img/1538372585.6c883d0b.jpg";